module.exports = __webpack_public_path__ + "img/list-bg@2x.bc41596e.png";